import { ChannelkartNetworkGet } from "../../services/networkService";

export async function getBannerData(): Promise<Record<string, any>[]> {
    const url = '/v1/query/brandWiseDashboard';
    try {
        const response = await ChannelkartNetworkGet(url);
        return response?.data?.features;
    } catch (err) {
        console.log(err);
        return [];
    }
}
